import { createFileRoute, redirect } from '@tanstack/react-router'
import { TransferDetailScreen } from '@/features/inventory-transfers/transfer-detail-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/transfers/$transferId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock_transfer.view'))
      throw redirect({ to: '/inventory/transfers' })
  },
  component: TransferDetailRoute,
})

function TransferDetailRoute() {
  const { transferId } = Route.useParams()

  return <TransferDetailScreen transferId={transferId} />
}
